import { handleActions } from 'redux-actions'
import {
  SET_ADDRESS_STATE,
  // SET_ADDRESS_DEFAULT,
  SET_ADDRESS_FORM,
  SET_ADDRESS_DATA,
  SET_ADDRESS_SELECTED
} from '../constants/addressConstant'
import { mapObjectKey, handleStateChange } from '../utils'

export let defaultForm = {
  id: '',
  flag: '1',
  isDefault: '0',
  phone: '',
  name: '',
  email: '',
  region: '',
  address: ''
}

let initState = {
  loading: false,
  invalid: false,
  errorMessage: '',
  list: [],
  form: defaultForm,
  selectedAddress: null
}

export let addressData = handleActions({
  [SET_ADDRESS_DATA]: (state, action) => {
    let map = {
      receivingMobile: 'phone',
      receivingName: 'name',
      receivingEmail: 'email',
      receivingAddress: 'address'
    }
    let list = action.payload.map(item => mapObjectKey(item, map))
    let newState = {
      ...state,
      loading: false,
      invalid: false,
      errorMessage: '',
      list
    }
    let newSelectedAddress = null
    let { selectedAddress } = state
    if (list.length > 0) {
      if (selectedAddress) {
        // 若有地址，有所选，判断已选是否仍在列表
        let find = list.find(item => item['id'] === selectedAddress['id'])
        newSelectedAddress = find ? find : null
      } else {
        // 若有地址，无所选，则默认第一个为所选
        // Object.assign(newState, { selectedAddress: list[0] })
        newSelectedAddress = list[0]
      }
    }
    // } else {
    // 若列表无地址，则清空所选地址
    // Object.assign(newState, { selectedAddress: null })
    // }
    Object.assign(newState, { selectedAddress: newSelectedAddress })
    return newState
  },
  [SET_ADDRESS_STATE]: handleStateChange,
  [SET_ADDRESS_SELECTED]: (state, action) => {
    return {
      ...state,
      selectedAddress: action.payload
    }
  },
  [SET_ADDRESS_FORM]: (state, action) => {
    return {
      ...state,
      form: action.payload
    }
  }
}, initState)
